import { useState } from 'react';

import plusIcon from '~/assets/icons/plus.svg';
import searchIcon from '~/assets/icons/search.svg';
import { playSound, Sound } from '~/assets/sounds';

import {
	StyledIcon,
	StyledSearchContainer,
	StyledSearchInput,
} from './RegionSearchInput.styled';

const RegionSearchInput = (props: React.HTMLAttributes<HTMLInputElement>) => {
	const [focused, setFocused] = useState(false);
	const [hovered, setHovered] = useState(false);

	return (
		<StyledSearchContainer $active={focused || hovered}>
			<StyledSearchInput
				{...props}
				placeholder="Выберите регион для поиска"
				onFocus={() => setFocused(true)}
				onBlur={() => setFocused(false)}
				onMouseEnter={() => {
					setHovered(true);
					playSound(Sound.LinkCursor);
				}}
				onMouseLeave={() => setHovered(false)}
				tabIndex={-1}
			/>
			{!focused && <StyledIcon src={searchIcon} />}
			{focused && (
				<StyledIcon
					src={plusIcon}
					style={{
						transform: 'translateY(-50%) rotate(45deg)',
						pointerEvents: 'all',
						cursor: 'pointer',
					}}
					onClick={() => {
						const event = {
							currentTarget: { value: '' },
						} as React.ChangeEvent<HTMLInputElement>;
						props.onChange?.(event);
						playSound(Sound.ClickButton);
					}}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				/>
			)}
		</StyledSearchContainer>
	);
};

export { RegionSearchInput };
